import {
  cssPropertyToDefaultValueMap as defaults,
  generateSkinDefaults,
} from '@wix/editor-elements-panel';
import type { SkinDefinition } from '@wix/editor-elements-panel/src/adapters/types';

const rootParams: SkinDefinition = {
  'root-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-left'],
    state: 'regular',
  },
  'root-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-right'],
    state: 'regular',
  },
  'root-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-top'],
    state: 'regular',
  },
  'root-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-bottom'],
    state: 'regular',
  },
  'root-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: '#fac313',
    state: 'regular',
  },
  'root-box-shadow': {
    type: 'BOX_SHADOW',
    defaultValue: defaults['box-shadow'],
    state: 'regular',
  },
  'root-border-top-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-left-radius'],
    state: 'regular',
  },
  'root-border-top-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-right-radius'],
    state: 'regular',
  },
  'root-border-bottom-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-left-radius'],
    state: 'regular',
  },
  'root-border-bottom-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-right-radius'],
    state: 'regular',
  },
};

const rootHoverParams: SkinDefinition = {
  'root-hover-border-left': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'root-hover-border-right': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'root-hover-border-top': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'root-hover-border-bottom': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'root-hover-background': {
    type: 'BACKGROUND_FILL',
    state: 'hover',
  },
  'root-hover-box-shadow': {
    type: 'BOX_SHADOW',
    state: 'hover',
  },
  'root-hover-border-top-left-radius': {
    type: 'BORDER',
    state: 'hover',
  },
  'root-hover-border-top-right-radius': {
    type: 'BORDER',
    state: 'hover',
  },
  'root-hover-border-bottom-left-radius': {
    type: 'BORDER',
    state: 'hover',
  },
  'root-hover-border-bottom-right-radius': {
    type: 'BORDER',
    state: 'hover',
  },
};

const itemParams: SkinDefinition = {
  'item-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-left'],
    state: 'regular',
  },
  'item-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-right'],
    state: 'regular',
  },
  'item-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-top'],
    state: 'regular',
  },
  'item-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['order-bottom'],
    state: 'regular',
  },
  'item-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: '#fac313',
    state: 'regular',
  },
  'item-box-shadow': {
    type: 'BOX_SHADOW',
    defaultValue: defaults['box-shadow'],
    state: 'regular',
  },
  'item-border-top-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-left-radius'],
    state: 'regular',
  },
  'item-border-top-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-right-radius'],
    state: 'regular',
  },
  'item-border-bottom-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-left-radius'],
    state: 'regular',
  },
  'item-border-bottom-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-right-radius'],
    state: 'regular',
  },
};

const itemHoverParams: SkinDefinition = {
  'item-hover-border-left': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'item-hover-border-right': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'item-hover-border-top': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'item-hover-border-bottom': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'item-hover-background': {
    type: 'BACKGROUND_FILL',
    state: 'hover',
  },
  'item-hover-box-shadow': {
    type: 'BOX_SHADOW',
    state: 'hover',
  },
  'item-hover-border-top-left-radius': {
    type: 'BORDER',
    state: 'hover',
  },
  'item-hover-border-top-right-radius': {
    type: 'BORDER',
    state: 'hover',
  },
  'item-hover-border-bottom-left-radius': {
    type: 'BORDER',
    state: 'hover',
  },
  'item-hover-border-bottom-right-radius': {
    type: 'BORDER',
    state: 'hover',
  },
};

const oldInternalTitleParams: SkinDefinition = {
  'old-internal-title-text-align': {
    type: 'TEXT_ALIGN',
    defaultValue: defaults['text-align'],
    state: 'regular',
  },
  'old-internal-title-text-highlight': {
    type: 'CSS_COLOR',
    defaultValue: 'none',
    state: 'regular',
  },
  'old-internal-title-text-transform': {
    type: 'TEXT_TRANSFORM',
    defaultValue: defaults['text-transform'],
    state: 'regular',
  },
  'old-internal-title-text-outline': {
    type: 'TEXT_OUTLINE',
    defaultValue: defaults.outline,
    state: 'regular',
  },
  'old-internal-title-text-shadow': {
    type: 'TEXT_SHADOW',
    defaultValue: '0px 0px transparent',
    state: 'regular',
  },
  'old-internal-title-font': {
    type: 'FONT',
    state: 'regular',
    defaultValue: 'font_8',
  },
  'old-internal-title-color': {
    type: 'CSS_COLOR',
    state: 'regular',
    defaultValue: '#FFFFFF',
  },
  'old-internal-title-letter-spacing': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['letter-spacing'],
  },
  'old-internal-title-line-height': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['line-height'],
  },
  'old-internal-title-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'regular',
    defaultValue: defaults['text-decoration-line'],
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'old-internal-title-direction': {
    type: 'DIRECTION',
    state: 'regular',
    defaultValue: defaults.direction,
  },
  'old-internal-title-padding-bottom': {
    type: 'SIZE',
    defaultValue: defaults['padding-bottom'],
    state: 'regular',
  },
  'old-internal-title-padding-top': {
    type: 'SIZE',
    defaultValue: defaults['padding-top'],
    state: 'regular',
  },
  'old-internal-title-padding-left': {
    type: 'SIZE',
    defaultValue: defaults['padding-left'],
    state: 'regular',
  },
  'old-internal-title-padding-right': {
    type: 'SIZE',
    defaultValue: defaults['padding-right'],
    state: 'regular',
  },
  'old-internal-title-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: '#fac313',
    state: 'regular',
  },
  'old-internal-title-border-top-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-left-radius'],
    state: 'regular',
  },
  'old-internal-title-border-top-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-right-radius'],
    state: 'regular',
  },
  'old-internal-title-border-bottom-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-left-radius'],
    state: 'regular',
  },
  'old-internal-title-border-bottom-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-right-radius'],
    state: 'regular',
  },
  'old-internal-title-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-left'],
    state: 'regular',
  },
  'old-internal-title-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-right'],
    state: 'regular',
  },
  'old-internal-title-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-top'],
    state: 'regular',
  },
  'old-internal-title-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-bottom'],
    state: 'regular',
  },
};

const oldInternalDescriptionParams: SkinDefinition = {
  'old-internal-description-text-align': {
    type: 'TEXT_ALIGN',
    defaultValue: defaults['text-align'],
    state: 'regular',
  },
  'old-internal-description-text-highlight': {
    type: 'CSS_COLOR',
    defaultValue: 'none',
    state: 'regular',
  },
  'old-internal-description-text-transform': {
    type: 'TEXT_TRANSFORM',
    defaultValue: defaults['text-transform'],
    state: 'regular',
  },
  'old-internal-description-text-outline': {
    type: 'TEXT_OUTLINE',
    defaultValue: defaults.outline,
    state: 'regular',
  },
  'old-internal-description-text-shadow': {
    type: 'TEXT_SHADOW',
    defaultValue: '0px 0px transparent',
    state: 'regular',
  },
  'old-internal-description-font': {
    type: 'FONT',
    state: 'regular',
    defaultValue: 'font_8',
  },
  'old-internal-description-color': {
    type: 'CSS_COLOR',
    state: 'regular',
    defaultValue: '#FFFFFF',
  },
  'old-internal-description-letter-spacing': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['letter-spacing'],
  },
  'old-internal-description-line-height': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['line-height'],
  },
  'old-internal-description-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'regular',
    defaultValue: defaults['text-decoration-line'],
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'old-internal-description-direction': {
    type: 'DIRECTION',
    state: 'regular',
    defaultValue: defaults.direction,
  },
  'old-internal-description-padding-bottom': {
    type: 'SIZE',
    defaultValue: defaults['padding-bottom'],
    state: 'regular',
  },
  'old-internal-description-padding-top': {
    type: 'SIZE',
    defaultValue: defaults['padding-top'],
    state: 'regular',
  },
  'old-internal-description-padding-left': {
    type: 'SIZE',
    defaultValue: defaults['padding-left'],
    state: 'regular',
  },
  'old-internal-description-padding-right': {
    type: 'SIZE',
    defaultValue: defaults['padding-right'],
    state: 'regular',
  },

  'old-internal-description-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: '#fac313',
    state: 'regular',
  },
  'old-internal-description-border-top-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-left-radius'],
    state: 'regular',
  },
  'old-internal-description-border-top-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-right-radius'],
    state: 'regular',
  },
  'old-internal-description-border-bottom-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-left-radius'],
    state: 'regular',
  },
  'old-internal-description-border-bottom-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-right-radius'],
    state: 'regular',
  },
  'old-internal-description-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-left'],
    state: 'regular',
  },
  'old-internal-description-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-right'],
    state: 'regular',
  },
  'old-internal-description-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-top'],
    state: 'regular',
  },
  'old-internal-description-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-bottom'],
    state: 'regular',
  },
};

const oldExternalTitleParams: SkinDefinition = {
  'old-external-title-text-align': {
    type: 'TEXT_ALIGN',
    defaultValue: defaults['text-align'],
    state: 'regular',
  },
  'old-external-title-text-highlight': {
    type: 'CSS_COLOR',
    defaultValue: 'none',
    state: 'regular',
  },
  'old-external-title-text-transform': {
    type: 'TEXT_TRANSFORM',
    defaultValue: defaults['text-transform'],
    state: 'regular',
  },
  'old-external-title-text-outline': {
    type: 'TEXT_OUTLINE',
    defaultValue: defaults.outline,
    state: 'regular',
  },
  'old-external-title-text-shadow': {
    type: 'TEXT_SHADOW',
    defaultValue: '0px 0px transparent',
    state: 'regular',
  },
  'old-external-title-font': {
    type: 'FONT',
    state: 'regular',
    defaultValue: 'font_8',
  },
  'old-external-title-color': {
    type: 'CSS_COLOR',
    state: 'regular',
    defaultValue: '#000000',
  },
  'old-external-title-letter-spacing': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['letter-spacing'],
  },
  'old-external-title-line-height': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['line-height'],
  },
  'old-external-title-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'regular',
    defaultValue: defaults['text-decoration-line'],
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'old-external-title-direction': {
    type: 'DIRECTION',
    state: 'regular',
    defaultValue: defaults.direction,
  },
  'old-external-title-padding-bottom': {
    type: 'SIZE',
    defaultValue: defaults['padding-bottom'],
    state: 'regular',
  },
  'old-external-title-padding-top': {
    type: 'SIZE',
    defaultValue: defaults['padding-top'],
    state: 'regular',
  },
  'old-external-title-padding-left': {
    type: 'SIZE',
    defaultValue: defaults['padding-left'],
    state: 'regular',
  },
  'old-external-title-padding-right': {
    type: 'SIZE',
    defaultValue: defaults['padding-right'],
    state: 'regular',
  },
  'old-external-title-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: '#fac313',
    state: 'regular',
  },
  'old-external-title-border-top-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-left-radius'],
    state: 'regular',
  },
  'old-external-title-border-top-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-right-radius'],
    state: 'regular',
  },
  'old-external-title-border-bottom-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-left-radius'],
    state: 'regular',
  },
  'old-external-title-border-bottom-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-right-radius'],
    state: 'regular',
  },
  'old-external-title-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-left'],
    state: 'regular',
  },
  'old-external-title-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-right'],
    state: 'regular',
  },
  'old-external-title-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-top'],
    state: 'regular',
  },
  'old-external-title-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-bottom'],
    state: 'regular',
  },
};

const oldExternalDescriptionParams: SkinDefinition = {
  'old-external-description-text-align': {
    type: 'TEXT_ALIGN',
    defaultValue: defaults['text-align'],
    state: 'regular',
  },
  'old-external-description-text-highlight': {
    type: 'CSS_COLOR',
    defaultValue: 'none',
    state: 'regular',
  },
  'old-external-description-text-transform': {
    type: 'TEXT_TRANSFORM',
    defaultValue: defaults['text-transform'],
    state: 'regular',
  },
  'old-external-description-text-outline': {
    type: 'TEXT_OUTLINE',
    defaultValue: defaults.outline,
    state: 'regular',
  },
  'old-external-description-text-shadow': {
    type: 'TEXT_SHADOW',
    defaultValue: '0px 0px transparent',
    state: 'regular',
  },
  'old-external-description-font': {
    type: 'FONT',
    state: 'regular',
    defaultValue: 'font_8',
  },
  'old-external-description-color': {
    type: 'CSS_COLOR',
    state: 'regular',
    defaultValue: '#000000',
  },
  'old-external-description-letter-spacing': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['letter-spacing'],
  },
  'old-external-description-line-height': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['line-height'],
  },
  'old-external-description-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'regular',
    defaultValue: defaults['text-decoration-line'],
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'old-external-description-direction': {
    type: 'DIRECTION',
    state: 'regular',
    defaultValue: defaults.direction,
  },
  'old-external-description-padding-bottom': {
    type: 'SIZE',
    defaultValue: defaults['padding-bottom'],
    state: 'regular',
  },
  'old-external-description-padding-top': {
    type: 'SIZE',
    defaultValue: defaults['padding-top'],
    state: 'regular',
  },
  'old-external-description-padding-left': {
    type: 'SIZE',
    defaultValue: defaults['padding-left'],
    state: 'regular',
  },
  'old-external-description-padding-right': {
    type: 'SIZE',
    defaultValue: defaults['padding-right'],
    state: 'regular',
  },
  'old-external-description-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: '#fac313',
    state: 'regular',
  },
  'old-external-description-border-top-left-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-top-left-radius'],
    state: 'regular',
  },
  'old-external-description-border-top-right-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-top-right-radius'],
    state: 'regular',
  },
  'old-external-description-border-bottom-left-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-bottom-left-radius'],
    state: 'regular',
  },
  'old-external-description-border-bottom-right-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-bottom-right-radius'],
    state: 'regular',
  },
  'old-external-description-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-left'],
    state: 'regular',
  },
  'old-external-description-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-right'],
    state: 'regular',
  },
  'old-external-description-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-top'],
    state: 'regular',
  },
  'old-external-description-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-bottom'],
    state: 'regular',
  },
};

const internalTitleParams: SkinDefinition = {
  'internal-title-text-align': {
    type: 'TEXT_ALIGN',
    defaultValue: defaults['text-align'],
    state: 'regular',
  },
  'internal-title-text-highlight': {
    type: 'CSS_COLOR',
    defaultValue: 'none',
    state: 'regular',
  },
  'internal-title-text-transform': {
    type: 'TEXT_TRANSFORM',
    defaultValue: defaults['text-transform'],
    state: 'regular',
  },
  'internal-title-text-outline': {
    type: 'TEXT_OUTLINE',
    defaultValue: defaults.outline,
    state: 'regular',
  },
  'internal-title-text-shadow': {
    type: 'TEXT_SHADOW',
    defaultValue: '0px 0px transparent',
    state: 'regular',
  },
  'internal-title-font': {
    type: 'FONT',
    state: 'regular',
    defaultValue: 'font_8',
  },
  'internal-title-color': {
    type: 'CSS_COLOR',
    state: 'regular',
    defaultValue: '#FFFFFF',
  },
  'internal-title-letter-spacing': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['letter-spacing'],
  },
  'internal-title-line-height': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['line-height'],
  },
  'internal-title-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'regular',
    defaultValue: defaults['text-decoration-line'],
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'internal-title-direction': {
    type: 'DIRECTION',
    state: 'regular',
    defaultValue: defaults.direction,
  },
  'internal-title-padding-bottom': {
    type: 'SIZE',
    defaultValue: defaults['padding-bottom'],
    state: 'regular',
  },
  'internal-title-padding-top': {
    type: 'SIZE',
    defaultValue: defaults['padding-top'],
    state: 'regular',
  },
  'internal-title-padding-left': {
    type: 'SIZE',
    defaultValue: defaults['padding-left'],
    state: 'regular',
  },
  'internal-title-padding-right': {
    type: 'SIZE',
    defaultValue: defaults['padding-right'],
    state: 'regular',
  },
  'internal-title-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: '#fac313',
    state: 'regular',
  },
  'internal-title-border-top-left-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-top-left-radius'],
    state: 'regular',
  },
  'internal-title-border-top-right-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-top-right-radius'],
    state: 'regular',
  },
  'internal-title-border-bottom-left-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-bottom-left-radius'],
    state: 'regular',
  },
  'internal-title-border-bottom-right-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-bottom-right-radius'],
    state: 'regular',
  },
  'internal-title-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-left'],
    state: 'regular',
  },
  'internal-title-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-right'],
    state: 'regular',
  },
  'internal-title-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-top'],
    state: 'regular',
  },
  'internal-title-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-bottom'],
    state: 'regular',
  },
};

const internalTitleHoverParams: SkinDefinition = {
  'internal-title-hover-text-align': {
    type: 'TEXT_ALIGN',
    state: 'hover',
  },
  'internal-title-hover-text-highlight': {
    type: 'CSS_COLOR',
    state: 'hover',
  },
  'internal-title-hover-text-transform': {
    type: 'TEXT_TRANSFORM',
    state: 'hover',
  },
  'internal-title-hover-text-outline': {
    type: 'TEXT_OUTLINE',
    state: 'hover',
  },
  'internal-title-hover-text-shadow': {
    type: 'TEXT_SHADOW',
    state: 'hover',
  },
  'internal-title-hover-font': {
    type: 'FONT',
    state: 'hover',
  },
  'internal-title-hover-color': {
    type: 'CSS_COLOR',
    state: 'hover',
  },
  'internal-title-hover-letter-spacing': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-title-hover-line-height': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-title-hover-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'hover',
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'internal-title-hover-direction': {
    type: 'DIRECTION',
    state: 'hover',
  },
  'internal-title-hover-padding-bottom': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-title-hover-padding-top': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-title-hover-padding-left': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-title-hover-padding-right': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-title-hover-background': {
    type: 'BACKGROUND_FILL',
    state: 'hover',
  },
  'internal-title-hover-border-top-left-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-title-hover-border-top-right-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-title-hover-border-bottom-left-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-title-hover-border-bottom-right-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-title-hover-border-left': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'internal-title-hover-border-right': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'internal-title-hover-border-top': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'internal-title-hover-border-bottom': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
};

const externalTitleParams: SkinDefinition = {
  'external-title-text-align': {
    type: 'TEXT_ALIGN',
    defaultValue: defaults['text-align'],
    state: 'regular',
  },
  'external-title-text-highlight': {
    type: 'CSS_COLOR',
    defaultValue: 'none',
    state: 'regular',
  },
  'external-title-text-transform': {
    type: 'TEXT_TRANSFORM',
    defaultValue: defaults['text-transform'],
    state: 'regular',
  },
  'external-title-text-outline': {
    type: 'TEXT_OUTLINE',
    defaultValue: defaults.outline,
    state: 'regular',
  },
  'external-title-text-shadow': {
    type: 'TEXT_SHADOW',
    defaultValue: '0px 0px transparent',
    state: 'regular',
  },
  'external-title-font': {
    type: 'FONT',
    state: 'regular',
    defaultValue: 'font_8',
  },
  'external-title-color': {
    type: 'CSS_COLOR',
    state: 'regular',
    defaultValue: '#000000',
  },
  'external-title-letter-spacing': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['letter-spacing'],
  },
  'external-title-line-height': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['line-height'],
  },
  'external-title-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'regular',
    defaultValue: defaults['text-decoration'],
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'external-title-direction': {
    type: 'DIRECTION',
    state: 'regular',
    defaultValue: defaults.direction,
  },
  'external-title-padding-bottom': {
    type: 'SIZE',
    defaultValue: defaults['padding-bottom'],
    state: 'regular',
  },
  'external-title-padding-top': {
    type: 'SIZE',
    defaultValue: defaults['padding-top'],
    state: 'regular',
  },
  'external-title-padding-left': {
    type: 'SIZE',
    defaultValue: defaults['padding-left'],
    state: 'regular',
  },
  'external-title-padding-right': {
    type: 'SIZE',
    defaultValue: defaults['padding-right'],
    state: 'regular',
  },
  'external-title-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: '#fac313',
    state: 'regular',
  },
  'external-title-border-top-left-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-top-left-radius'],
    state: 'regular',
  },
  'external-title-border-top-right-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-top-right-radius'],
    state: 'regular',
  },
  'external-title-border-bottom-left-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-bottom-left-radius'],
    state: 'regular',
  },
  'external-title-border-bottom-right-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-bottom-right-radius'],
    state: 'regular',
  },
  'external-title-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-left'],
    state: 'regular',
  },
  'external-title-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-right'],
    state: 'regular',
  },
  'external-title-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-top'],
    state: 'regular',
  },
  'external-title-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-bottom'],
    state: 'regular',
  },
};

const externalTitleHoverParams: SkinDefinition = {
  'external-title-hover-text-align': {
    type: 'TEXT_ALIGN',
    state: 'hover',
  },
  'external-title-hover-text-highlight': {
    type: 'CSS_COLOR',
    state: 'hover',
  },
  'external-title-hover-text-transform': {
    type: 'TEXT_TRANSFORM',
    state: 'hover',
  },
  'external-title-hover-text-outline': {
    type: 'TEXT_OUTLINE',
    state: 'hover',
  },
  'external-title-hover-text-shadow': {
    type: 'TEXT_SHADOW',
    state: 'hover',
  },
  'external-title-hover-font': {
    type: 'FONT',
    state: 'hover',
  },
  'external-title-hover-color': {
    type: 'CSS_COLOR',
    state: 'hover',
  },
  'external-title-hover-letter-spacing': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-title-hover-line-height': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-title-hover-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'hover',
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'external-title-hover-direction': {
    type: 'DIRECTION',
    state: 'hover',
  },
  'external-title-hover-padding-bottom': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-title-hover-padding-top': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-title-hover-padding-left': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-title-hover-padding-right': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-title-hover-background': {
    type: 'BACKGROUND_FILL',
    state: 'hover',
  },
  'external-title-hover-border-top-left-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-title-hover-border-top-right-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-title-hover-border-bottom-left-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-title-hover-border-bottom-right-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-title-hover-border-left': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'external-title-hover-border-right': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'external-title-hover-border-top': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'external-title-hover-border-bottom': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
};

const internalDescriptionParams: SkinDefinition = {
  'internal-description-text-align': {
    type: 'TEXT_ALIGN',
    defaultValue: defaults['text-align'],
    state: 'regular',
  },
  'internal-description-text-highlight': {
    type: 'CSS_COLOR',
    defaultValue: 'none',
    state: 'regular',
  },
  'internal-description-text-transform': {
    type: 'TEXT_TRANSFORM',
    defaultValue: defaults['text-transform'],
    state: 'regular',
  },
  'internal-description-text-outline': {
    type: 'TEXT_OUTLINE',
    defaultValue: defaults.outline,
    state: 'regular',
  },
  'internal-description-text-shadow': {
    type: 'TEXT_SHADOW',
    defaultValue: '0px 0px transparent',
    state: 'regular',
  },
  'internal-description-font': {
    type: 'FONT',
    state: 'regular',
    defaultValue: 'font_8',
  },
  'internal-description-color': {
    type: 'CSS_COLOR',
    state: 'regular',
    defaultValue: '#FFFFFF',
  },
  'internal-description-letter-spacing': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['letter-spacing'],
  },
  'internal-description-line-height': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['line-height'],
  },
  'internal-description-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'regular',
    defaultValue: defaults['text-decoration'],
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'internal-description-direction': {
    type: 'DIRECTION',
    state: 'regular',
    defaultValue: defaults.direction,
  },
  'internal-description-padding-bottom': {
    type: 'SIZE',
    defaultValue: defaults['padding-bottom'],
    state: 'regular',
  },
  'internal-description-padding-top': {
    type: 'SIZE',
    defaultValue: defaults['padding-top'],
    state: 'regular',
  },
  'internal-description-padding-left': {
    type: 'SIZE',
    defaultValue: defaults['padding-left'],
    state: 'regular',
  },
  'internal-description-padding-right': {
    type: 'SIZE',
    defaultValue: defaults['padding-right'],
    state: 'regular',
  },
  'internal-description-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: '#fac313',
    state: 'regular',
  },
  'internal-description-border-top-left-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-top-left-radius'],
    state: 'regular',
  },
  'internal-description-border-top-right-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-top-right-radius'],
    state: 'regular',
  },
  'internal-description-border-bottom-left-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-bottom-left-radius'],
    state: 'regular',
  },
  'internal-description-border-bottom-right-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-bottom-right-radius'],
    state: 'regular',
  },
  'internal-description-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-left'],
    state: 'regular',
  },
  'internal-description-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-right'],
    state: 'regular',
  },
  'internal-description-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-top'],
    state: 'regular',
  },
  'internal-description-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-bottom'],
    state: 'regular',
  },
};

const internalDescriptionHoverParams: SkinDefinition = {
  'internal-description-hover-text-align': {
    type: 'TEXT_ALIGN',
    state: 'hover',
  },
  'internal-description-hover-text-highlight': {
    type: 'CSS_COLOR',
    state: 'hover',
  },
  'internal-description-hover-text-transform': {
    type: 'TEXT_TRANSFORM',
    state: 'hover',
  },
  'internal-description-hover-text-outline': {
    type: 'TEXT_OUTLINE',
    state: 'hover',
  },
  'internal-description-hover-text-shadow': {
    type: 'TEXT_SHADOW',
    state: 'hover',
  },
  'internal-description-hover-font': {
    type: 'FONT',
    state: 'hover',
  },
  'internal-description-hover-color': {
    type: 'CSS_COLOR',
    state: 'hover',
  },
  'internal-description-hover-letter-spacing': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-description-hover-line-height': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-description-hover-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'hover',
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'internal-description-hover-direction': {
    type: 'DIRECTION',
    state: 'hover',
  },
  'internal-description-hover-padding-bottom': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-description-hover-padding-top': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-description-hover-padding-left': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-description-hover-padding-right': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-description-hover-background': {
    type: 'BACKGROUND_FILL',
    state: 'hover',
  },
  'internal-description-hover-border-top-left-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-description-hover-border-top-right-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-description-hover-border-bottom-left-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-description-hover-border-bottom-right-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-description-hover-border-left': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'internal-description-hover-border-right': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'internal-description-hover-border-top': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'internal-description-hover-border-bottom': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
};

const externalDescriptionParams: SkinDefinition = {
  'external-description-text-align': {
    type: 'TEXT_ALIGN',
    defaultValue: defaults['text-align'],
    state: 'regular',
  },
  'external-description-text-highlight': {
    type: 'CSS_COLOR',
    defaultValue: 'none',
    state: 'regular',
  },
  'external-description-text-transform': {
    type: 'TEXT_TRANSFORM',
    defaultValue: defaults['text-transform'],
    state: 'regular',
  },
  'external-description-text-outline': {
    type: 'TEXT_OUTLINE',
    defaultValue: defaults.outline,
    state: 'regular',
  },
  'external-description-text-shadow': {
    type: 'TEXT_SHADOW',
    defaultValue: '0px 0px transparent',
    state: 'regular',
  },
  'external-description-font': {
    type: 'FONT',
    state: 'regular',
    defaultValue: 'font_8',
  },
  'external-description-color': {
    type: 'CSS_COLOR',
    state: 'regular',
    defaultValue: '#000000',
  },
  'external-description-letter-spacing': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['letter-spacing'],
  },
  'external-description-line-height': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['line-height'],
  },
  'external-description-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'regular',
    defaultValue: defaults['text-decoration'],
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'external-description-direction': {
    type: 'DIRECTION',
    state: 'regular',
    defaultValue: defaults.direction,
  },
  'external-description-padding-bottom': {
    type: 'SIZE',
    defaultValue: defaults['padding-bottom'],
    state: 'regular',
  },
  'external-description-padding-top': {
    type: 'SIZE',
    defaultValue: defaults['padding-top'],
    state: 'regular',
  },
  'external-description-padding-left': {
    type: 'SIZE',
    defaultValue: defaults['padding-left'],
    state: 'regular',
  },
  'external-description-padding-right': {
    type: 'SIZE',
    defaultValue: defaults['padding-right'],
    state: 'regular',
  },
  'external-description-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: '#fac313',
    state: 'regular',
  },
  'external-description-border-top-left-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-top-left-radius'],
    state: 'regular',
  },
  'external-description-border-top-right-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-top-right-radius'],
    state: 'regular',
  },
  'external-description-border-bottom-left-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-bottom-left-radius'],
    state: 'regular',
  },
  'external-description-border-bottom-right-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-bottom-right-radius'],
    state: 'regular',
  },
  'external-description-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-left'],
    state: 'regular',
  },
  'external-description-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-right'],
    state: 'regular',
  },
  'external-description-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-top'],
    state: 'regular',
  },
  'external-description-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-bottom'],
    state: 'regular',
  },
};

const externalDescriptionHoverParams: SkinDefinition = {
  'external-description-hover-text-align': {
    type: 'TEXT_ALIGN',
    state: 'hover',
  },
  'external-description-hover-text-highlight': {
    type: 'CSS_COLOR',
    state: 'hover',
  },
  'external-description-hover-text-transform': {
    type: 'TEXT_TRANSFORM',
    state: 'hover',
  },
  'external-description-hover-text-outline': {
    type: 'TEXT_OUTLINE',
    state: 'hover',
  },
  'external-description-hover-text-shadow': {
    type: 'TEXT_SHADOW',
    state: 'hover',
  },
  'external-description-hover-font': {
    type: 'FONT',
    state: 'hover',
  },
  'external-description-hover-color': {
    type: 'CSS_COLOR',
    state: 'hover',
  },
  'external-description-hover-letter-spacing': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-description-hover-line-height': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-description-hover-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'hover',
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'external-description-hover-direction': {
    type: 'DIRECTION',
    state: 'hover',
  },
  'external-description-hover-padding-bottom': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-description-hover-padding-top': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-description-hover-padding-left': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-description-hover-padding-right': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-description-hover-background': {
    type: 'BACKGROUND_FILL',
    state: 'hover',
  },
  'external-description-hover-border-top-left-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-description-hover-border-top-right-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-description-hover-border-bottom-left-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-description-hover-border-bottom-right-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-description-hover-border-left': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'external-description-hover-border-right': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'external-description-hover-border-top': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'external-description-hover-border-bottom': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
};

const overlayParams: SkinDefinition = {
  'overlay-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-left'],
    state: 'regular',
  },
  'overlay-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-right'],
    state: 'regular',
  },
  'overlay-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-top'],
    state: 'regular',
  },
  'overlay-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-bottom'],
    state: 'regular',
  },
  'overlay-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: '#000000',
    state: 'regular',
  },
  'overlay-border-top-left-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-top-left-radius'],
    state: 'regular',
  },
  'overlay-border-top-right-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-top-right-radius'],
    state: 'regular',
  },
  'overlay-border-bottom-left-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-bottom-left-radius'],
    state: 'regular',
  },
  'overlay-border-bottom-right-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-bottom-right-radius'],
    state: 'regular',
  },
  'overlay-box-shadow': {
    type: 'BOX_SHADOW',
    defaultValue: defaults['box-shadow'],
    state: 'regular',
  },
};

const overlayHoverParams: SkinDefinition = {
  'overlay-hover-border-left': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'overlay-hover-border-right': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'overlay-hover-border-top': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'overlay-hover-border-bottom': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'overlay-hover-background': {
    type: 'BACKGROUND_FILL',
    state: 'hover',
  },
  'overlay-hover-border-top-left-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'overlay-hover-border-top-right-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'overlay-hover-border-bottom-left-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'overlay-hover-border-bottom-right-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'overlay-hover-box-shadow': {
    type: 'BOX_SHADOW',
    state: 'hover',
  },
};

const contentParams: SkinDefinition = {
  'content-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: '#fac313',
    state: 'regular',
  },
  'content-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-left'],
    state: 'regular',
  },
  'content-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-right'],
    state: 'regular',
  },
  'content-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-top'],
    state: 'regular',
  },
  'content-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-bottom'],
    state: 'regular',
  },
  'content-border-top-left-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-top-left-radius'],
    state: 'regular',
  },
  'content-border-top-right-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-top-right-radius'],
    state: 'regular',
  },
  'content-border-bottom-left-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-bottom-left-radius'],
    state: 'regular',
  },
  'content-border-bottom-right-radius': {
    type: 'SIZE',
    defaultValue: defaults['border-bottom-right-radius'],
    state: 'regular',
  },
  'content-box-shadow': {
    type: 'BOX_SHADOW',
    defaultValue: defaults['box-shadow'],
    state: 'regular',
  },
};

const contentHoverParams: SkinDefinition = {
  'content-hover-background': {
    type: 'BACKGROUND_FILL',
    state: 'hover',
  },
  'content-hover-border-left': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'content-hover-border-right': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'content-hover-border-top': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'content-hover-border-bottom': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'content-hover-border-top-left-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'content-hover-border-top-right-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'content-hover-border-bottom-left-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'content-hover-border-bottom-right-radius': {
    type: 'BORDER',
    state: 'hover',
  },
  'content-hover-box-shadow': {
    type: 'BOX_SHADOW',
    state: 'hover',
  },
};

const loadMoreButtonParams: SkinDefinition = {
  'load-more-button-text-align': {
    type: 'TEXT_ALIGN',
    defaultValue: defaults['text-align'],
    state: 'regular',
  },
  'load-more-button-text-highlight': {
    type: 'CSS_COLOR',
    defaultValue: 'none',
    state: 'regular',
  },
  'load-more-button-text-transform': {
    type: 'TEXT_TRANSFORM',
    defaultValue: defaults['text-transform'],
    state: 'regular',
  },
  'load-more-button-text-outline': {
    type: 'TEXT_OUTLINE',
    defaultValue: defaults.outline,
    state: 'regular',
  },
  'load-more-button-text-shadow': {
    type: 'TEXT_SHADOW',
    defaultValue: '0px 0px transparent',
    state: 'regular',
  },
  'load-more-button-font': {
    type: 'FONT',
    state: 'regular',
    defaultValue: 'font_8',
  },
  'load-more-button-color': {
    type: 'CSS_COLOR',
    state: 'regular',
    defaultValue: '#000000',
  },
  'load-more-button-letter-spacing': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['letter-spacing'],
  },
  'load-more-button-line-height': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: '1em',
  },
  'load-more-button-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'regular',
    defaultValue: defaults['text-decoration'],
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'load-more-button-direction': {
    type: 'DIRECTION',
    state: 'regular',
    defaultValue: defaults.direction,
  },
  'load-more-button-padding-bottom': {
    type: 'SIZE',
    defaultValue: '11px',
    state: 'regular',
  },
  'load-more-button-padding-top': {
    type: 'SIZE',
    defaultValue: '11px',
    state: 'regular',
  },
  'load-more-button-padding-left': {
    type: 'SIZE',
    defaultValue: '29px',
    state: 'regular',
  },
  'load-more-button-padding-right': {
    type: 'SIZE',
    defaultValue: '29px',
    state: 'regular',
  },
  'load-more-button-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: '2px solid #5d5d61',
    state: 'regular',
  },
  'load-more-button-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: '2px solid #5d5d61',
    state: 'regular',
  },
  'load-more-button-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: '2px solid #5d5d61',
    state: 'regular',
  },
  'load-more-button-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: '2px solid #5d5d61',
    state: 'regular',
  },
  'load-more-button-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: '#fac313',
    state: 'regular',
  },
  'load-more-button-box-shadow': {
    type: 'BOX_SHADOW',
    defaultValue: defaults['box-shadow'],
    state: 'regular',
  },
  'load-more-button-border-top-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-left-radius'],
    state: 'regular',
  },
  'load-more-button-border-top-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-right-radius'],
    state: 'regular',
  },
  'load-more-button-border-bottom-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-left-radius'],
    state: 'regular',
  },
  'load-more-button-border-bottom-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-right-radius'],
    state: 'regular',
  },
};

const navigationArrowsIconParams: SkinDefinition = {
  'navigation-arrows-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-left'],
    state: 'regular',
  },
  'navigation-arrows-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-right'],
    state: 'regular',
  },
  'navigation-arrows-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-top'],
    state: 'regular',
  },
  'navigation-arrows-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: defaults['border-bottom'],
    state: 'regular',
  },
  'navigation-arrows-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: '#fac313',
    state: 'regular',
  },
  'navigation-arrows-box-shadow': {
    type: 'BOX_SHADOW',
    defaultValue: defaults['box-shadow'],
    state: 'regular',
  },
  'navigation-arrows-border-top-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-left-radius'],
    state: 'regular',
  },
  'navigation-arrows-border-top-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-right-radius'],
    state: 'regular',
  },
  'navigation-arrows-border-bottom-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-left-radius'],
    state: 'regular',
  },
  'navigation-arrows-border-bottom-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-right-radius'],
    state: 'regular',
  },
  'navigation-arrows-icon-display': {
    type: 'DISPLAY',
    defaultValue: 'initial',
    state: 'regular',
  },
  'navigation-arrows-icon-size': {
    type: 'SIZE',
    defaultValue: '10px',
    state: 'regular',
  },
  'navigation-arrows-icon-color': {
    type: 'CSS_COLOR',
    defaultValue: 'rgba(0,0,0,1)',
    state: 'regular',
  },
  'navigation-arrows-icon-rotation': {
    type: 'CSSString',
    defaultValue: '0',
    state: 'regular',
  },
};

const navigationArrowsIconHoverParams: SkinDefinition = {
  'navigation-arrows-hover-border-left': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'navigation-arrows-hover-border-right': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'navigation-arrows-hover-border-top': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'navigation-arrows-hover-border-bottom': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'navigation-arrows-hover-background': {
    type: 'BACKGROUND_FILL',
    state: 'hover',
  },
  'navigation-arrows-hover-box-shadow': {
    type: 'BOX_SHADOW',
    state: 'hover',
  },
  'navigation-arrows-hover-border-top-left-radius': {
    type: 'BORDER',
    state: 'hover',
  },
  'navigation-arrows-hover-border-top-right-radius': {
    type: 'BORDER',
    state: 'hover',
  },
  'navigation-arrows-hover-border-bottom-left-radius': {
    type: 'BORDER',
    state: 'hover',
  },
  'navigation-arrows-hover-border-bottom-right-radius': {
    type: 'BORDER',
    state: 'hover',
  },
  'navigation-arrows-hover-icon-display': {
    type: 'DISPLAY',
    state: 'hover',
  },
  'navigation-arrows-hover-icon-color': {
    type: 'CSS_COLOR',
    state: 'hover',
  },
  'navigation-arrows-hover-icon-size': {
    type: 'SIZE',
    state: 'hover',
  },
  'navigation-arrows-hover-icon-rotation': {
    type: 'CSSString',
    state: 'hover',
  },
};

const internalCustomButtonParams: SkinDefinition = {
  'internal-custom-button-text-align': {
    type: 'TEXT_ALIGN',
    defaultValue: defaults['text-align'],
    state: 'regular',
  },
  'internal-custom-button-text-highlight': {
    type: 'CSS_COLOR',
    defaultValue: 'none',
    state: 'regular',
  },
  'internal-custom-button-text-transform': {
    type: 'TEXT_TRANSFORM',
    defaultValue: defaults['text-transform'],
    state: 'regular',
  },
  'internal-custom-button-text-outline': {
    type: 'TEXT_OUTLINE',
    defaultValue: defaults.outline,
    state: 'regular',
  },
  'internal-custom-button-text-shadow': {
    type: 'TEXT_SHADOW',
    defaultValue: '0px 0px transparent',
    state: 'regular',
  },
  'internal-custom-button-font': {
    type: 'FONT',
    state: 'regular',
    defaultValue: 'font_8',
  },
  'internal-custom-button-color': {
    type: 'CSS_COLOR',
    state: 'regular',
    defaultValue: '#FFFFFF',
  },
  'internal-custom-button-letter-spacing': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['letter-spacing'],
  },
  'internal-custom-button-line-height': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['line-height'],
  },
  'internal-custom-button-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'regular',
    defaultValue: defaults['text-decoration'],
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'internal-custom-button-direction': {
    type: 'DIRECTION',
    state: 'regular',
    defaultValue: defaults.direction,
  },
  'internal-custom-button-padding-bottom': {
    type: 'SIZE',
    defaultValue: '16px',
    state: 'regular',
  },
  'internal-custom-button-padding-top': {
    type: 'SIZE',
    defaultValue: '16px',
    state: 'regular',
  },
  'internal-custom-button-padding-left': {
    type: 'SIZE',
    defaultValue: '16px',
    state: 'regular',
  },
  'internal-custom-button-padding-right': {
    type: 'SIZE',
    defaultValue: '16px',
    state: 'regular',
  },
  'internal-custom-button-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: '1px solid #FFFFFF',
    state: 'regular',
  },
  'internal-custom-button-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: '1px solid #FFFFFF',
    state: 'regular',
  },
  'internal-custom-button-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: '1px solid #FFFFFF',
    state: 'regular',
  },
  'internal-custom-button-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: '1px solid #FFFFFF',
    state: 'regular',
  },
  'internal-custom-button-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: '#fac313',
    state: 'regular',
  },
  'internal-custom-button-box-shadow': {
    type: 'BOX_SHADOW',
    defaultValue: defaults['box-shadow'],
    state: 'regular',
  },
  'internal-custom-button-border-top-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-left-radius'],
    state: 'regular',
  },
  'internal-custom-button-border-top-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-right-radius'],
    state: 'regular',
  },
  'internal-custom-button-border-bottom-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-left-radius'],
    state: 'regular',
  },
  'internal-custom-button-border-bottom-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-right-radius'],
    state: 'regular',
  },
};

const internalCustomButtonHoverParams: SkinDefinition = {
  'internal-custom-button-hover-text-align': {
    type: 'TEXT_ALIGN',
    state: 'hover',
  },
  'internal-custom-button-hover-text-highlight': {
    type: 'CSS_COLOR',
    state: 'hover',
  },
  'internal-custom-button-hover-text-transform': {
    type: 'TEXT_TRANSFORM',
    state: 'hover',
  },
  'internal-custom-button-hover-text-outline': {
    type: 'TEXT_OUTLINE',
    state: 'hover',
  },
  'internal-custom-button-hover-text-shadow': {
    type: 'TEXT_SHADOW',
    state: 'hover',
  },
  'internal-custom-button-hover-font': {
    type: 'FONT',
    state: 'hover',
  },
  'internal-custom-button-hover-color': {
    type: 'CSS_COLOR',
    state: 'hover',
  },
  'internal-custom-button-hover-letter-spacing': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-custom-button-hover-line-height': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-custom-button-hover-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'hover',
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'internal-custom-button-hover-direction': {
    type: 'DIRECTION',
    state: 'hover',
  },
  'internal-custom-button-hover-padding-bottom': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-custom-button-hover-padding-top': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-custom-button-hover-padding-left': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-custom-button-hover-padding-right': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-custom-button-hover-border-left': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'internal-custom-button-hover-border-right': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'internal-custom-button-hover-border-top': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'internal-custom-button-hover-border-bottom': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'internal-custom-button-hover-background': {
    type: 'BACKGROUND_FILL',
    state: 'hover',
  },
  'internal-custom-button-hover-box-shadow': {
    type: 'BOX_SHADOW',
    state: 'hover',
  },
  'internal-custom-button-hover-border-top-left-radius': {
    type: 'BORDER',
    state: 'hover',
  },
  'internal-custom-button-hover-border-top-right-radius': {
    type: 'BORDER',
    state: 'hover',
  },
  'internal-custom-button-hover-border-bottom-left-radius': {
    type: 'BORDER',
    state: 'hover',
  },
  'internal-custom-button-hover-border-bottom-right-radius': {
    type: 'BORDER',
    state: 'hover',
  },
};

const externalCustomButtonParams: SkinDefinition = {
  'external-custom-button-text-align': {
    type: 'TEXT_ALIGN',
    defaultValue: defaults['text-align'],
    state: 'regular',
  },
  'external-custom-button-text-highlight': {
    type: 'CSS_COLOR',
    defaultValue: 'none',
    state: 'regular',
  },
  'external-custom-button-text-transform': {
    type: 'TEXT_TRANSFORM',
    defaultValue: defaults['text-transform'],
    state: 'regular',
  },
  'external-custom-button-text-outline': {
    type: 'TEXT_OUTLINE',
    defaultValue: defaults.outline,
    state: 'regular',
  },
  'external-custom-button-text-shadow': {
    type: 'TEXT_SHADOW',
    defaultValue: '0px 0px transparent',
    state: 'regular',
  },
  'external-custom-button-font': {
    type: 'FONT',
    state: 'regular',
    defaultValue: 'font_8',
  },
  'external-custom-button-color': {
    type: 'CSS_COLOR',
    state: 'regular',
    defaultValue: '#000000',
  },
  'external-custom-button-letter-spacing': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['letter-spacing'],
  },
  'external-custom-button-line-height': {
    type: 'SIZE',
    state: 'regular',
    defaultValue: defaults['line-height'],
  },
  'external-custom-button-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'regular',
    defaultValue: defaults['text-decoration'],
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'external-custom-button-direction': {
    type: 'DIRECTION',
    state: 'regular',
    defaultValue: defaults.direction,
  },
  'external-custom-button-padding-bottom': {
    type: 'SIZE',
    defaultValue: '16px',
    state: 'regular',
  },
  'external-custom-button-padding-top': {
    type: 'SIZE',
    defaultValue: '16px',
    state: 'regular',
  },
  'external-custom-button-padding-left': {
    type: 'SIZE',
    defaultValue: '16px',
    state: 'regular',
  },
  'external-custom-button-padding-right': {
    type: 'SIZE',
    defaultValue: '16px',
    state: 'regular',
  },
  'external-custom-button-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: '1px solid #000000',
    state: 'regular',
  },
  'external-custom-button-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: '1px solid #000000',
    state: 'regular',
  },
  'external-custom-button-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: '1px solid #000000',
    state: 'regular',
  },
  'external-custom-button-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: '1px solid #000000',
    state: 'regular',
  },
  'external-custom-button-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: '#fac313',
    state: 'regular',
  },
  'external-custom-button-box-shadow': {
    type: 'BOX_SHADOW',
    defaultValue: defaults['box-shadow'],
    state: 'regular',
  },
  'external-custom-button-border-top-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-left-radius'],
    state: 'regular',
  },
  'external-custom-button-border-top-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-top-right-radius'],
    state: 'regular',
  },
  'external-custom-button-border-bottom-left-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-left-radius'],
    state: 'regular',
  },
  'external-custom-button-border-bottom-right-radius': {
    type: 'BORDER',
    defaultValue: defaults['border-bottom-right-radius'],
    state: 'regular',
  },
};

const externalCustomButtonHoverParams: SkinDefinition = {
  'external-custom-button-hover-text-align': {
    type: 'TEXT_ALIGN',
    state: 'hover',
  },
  'external-custom-button-hover-text-highlight': {
    type: 'CSS_COLOR',
    state: 'hover',
  },
  'external-custom-button-hover-text-transform': {
    type: 'TEXT_TRANSFORM',
    state: 'hover',
  },
  'external-custom-button-hover-text-outline': {
    type: 'TEXT_OUTLINE',
    state: 'hover',
  },
  'external-custom-button-hover-text-shadow': {
    type: 'TEXT_SHADOW',
    state: 'hover',
  },
  'external-custom-button-hover-font': {
    type: 'FONT',
    state: 'hover',
  },
  'external-custom-button-hover-color': {
    type: 'CSS_COLOR',
    state: 'hover',
  },
  'external-custom-button-hover-letter-spacing': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-custom-button-hover-line-height': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-custom-button-hover-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'hover',
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'external-custom-button-hover-direction': {
    type: 'DIRECTION',
    state: 'hover',
  },
  'external-custom-button-hover-padding-bottom': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-custom-button-hover-padding-top': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-custom-button-hover-padding-left': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-custom-button-hover-padding-right': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-custom-button-hover-border-left': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'external-custom-button-hover-border-right': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'external-custom-button-hover-border-top': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'external-custom-button-hover-border-bottom': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'external-custom-button-hover-background': {
    type: 'BACKGROUND_FILL',
    state: 'hover',
  },
  'external-custom-button-hover-box-shadow': {
    type: 'BOX_SHADOW',
    state: 'hover',
  },
  'external-custom-button-hover-border-top-left-radius': {
    type: 'BORDER',
    state: 'hover',
  },
  'external-custom-button-hover-border-top-right-radius': {
    type: 'BORDER',
    state: 'hover',
  },
  'external-custom-button-hover-border-bottom-left-radius': {
    type: 'BORDER',
    state: 'hover',
  },
  'external-custom-button-hover-border-bottom-right-radius': {
    type: 'BORDER',
    state: 'hover',
  },
};

const internalInfoSocialButtonsParams: SkinDefinition = {
  'internal-info-social-buttons-icon-display': {
    type: 'DISPLAY',
    defaultValue: 'initial',
    state: 'regular',
  },
  'internal-info-social-buttons-icon-color': {
    type: 'CSS_COLOR',
    defaultValue: 'rgba(255,255,255,1)',
    state: 'regular',
  },
  'internal-info-social-buttons-icon-size': {
    type: 'SIZE',
    defaultValue: '24px',
    state: 'regular',
  },
  'internal-info-social-buttons-icon-rotation': {
    type: 'CSSString',
    defaultValue: '0',
    state: 'regular',
  },
  'internal-info-social-buttons-padding-bottom': {
    type: 'SIZE',
    defaultValue: defaults['padding-bottom'],
    state: 'regular',
  },
  'internal-info-social-buttons-padding-top': {
    type: 'SIZE',
    defaultValue: defaults['padding-top'],
    state: 'regular',
  },
  'internal-info-social-buttons-padding-left': {
    type: 'SIZE',
    defaultValue: defaults['padding-left'],
    state: 'regular',
  },
  'internal-info-social-buttons-padding-right': {
    type: 'SIZE',
    defaultValue: defaults['padding-right'],
    state: 'regular',
  },
};

const internalInfoSocialButtonsHoverParams: SkinDefinition = {
  'internal-info-social-buttons-hover-icon-display': {
    type: 'DISPLAY',
    state: 'hover',
  },
  'internal-info-social-buttons-hover-icon-color': {
    type: 'CSS_COLOR',
    state: 'hover',
  },
  'internal-info-social-buttons-hover-icon-size': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-info-social-buttons-hover-icon-rotation': {
    type: 'CSSString',
    state: 'hover',
  },
  'internal-info-social-buttons-hover-padding-bottom': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-info-social-buttons-hover-padding-top': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-info-social-buttons-hover-padding-left': {
    type: 'SIZE',
    state: 'hover',
  },
  'internal-info-social-buttons-hover-padding-right': {
    type: 'SIZE',
    state: 'hover',
  },
};

const externalInfoSocialButtonsParams: SkinDefinition = {
  'external-info-social-buttons-icon-display': {
    type: 'DISPLAY',
    defaultValue: 'initial',
    state: 'regular',
  },
  'external-info-social-buttons-icon-color': {
    type: 'CSS_COLOR',
    defaultValue: 'rgba(0,0,0,1)',
    state: 'regular',
  },
  'external-info-social-buttons-icon-size': {
    type: 'SIZE',
    defaultValue: '24px',
    state: 'regular',
  },
  'external-info-social-buttons-icon-rotation': {
    type: 'CSSString',
    defaultValue: '0',
    state: 'regular',
  },
  'external-info-social-buttons-padding-bottom': {
    type: 'SIZE',
    defaultValue: defaults['padding-bottom'],
    state: 'regular',
  },
  'external-info-social-buttons-padding-top': {
    type: 'SIZE',
    defaultValue: defaults['padding-top'],
    state: 'regular',
  },
  'external-info-social-buttons-padding-left': {
    type: 'SIZE',
    defaultValue: defaults['padding-left'],
    state: 'regular',
  },
  'external-info-social-buttons-padding-right': {
    type: 'SIZE',
    defaultValue: defaults['padding-right'],
    state: 'regular',
  },
};

const externalInfoSocialButtonsHoverParams: SkinDefinition = {
  'external-info-social-buttons-hover-icon-display': {
    type: 'DISPLAY',
    state: 'hover',
  },
  'external-info-social-buttons-hover-icon-color': {
    type: 'CSS_COLOR',
    state: 'hover',
  },
  'external-info-social-buttons-hover-icon-size': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-info-social-buttons-hover-icon-rotation': {
    type: 'CSSString',
    state: 'hover',
  },
  'external-info-social-buttons-hover-padding-bottom': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-info-social-buttons-hover-padding-top': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-info-social-buttons-hover-padding-left': {
    type: 'SIZE',
    state: 'hover',
  },
  'external-info-social-buttons-hover-padding-right': {
    type: 'SIZE',
    state: 'hover',
  },
};

export const proGallerySkinDefinition: Record<string, SkinDefinition> = {
  'wixui.skins.ProGallery': {
    ...rootParams,
    ...rootHoverParams,
    ...itemParams,
    ...itemHoverParams,
    ...overlayParams,
    ...overlayHoverParams,
    ...contentParams,
    ...contentHoverParams,
    ...oldInternalTitleParams,
    ...oldInternalDescriptionParams,
    ...oldExternalTitleParams,
    ...oldExternalDescriptionParams,
    ...internalTitleParams,
    ...internalTitleHoverParams,
    ...externalTitleParams,
    ...externalTitleHoverParams,
    ...internalDescriptionParams,
    ...internalDescriptionHoverParams,
    ...externalDescriptionParams,
    ...externalDescriptionHoverParams,
    ...loadMoreButtonParams,
    ...navigationArrowsIconParams,
    ...navigationArrowsIconHoverParams,
    ...internalCustomButtonParams,
    ...internalCustomButtonHoverParams,
    ...externalCustomButtonParams,
    ...externalCustomButtonHoverParams,
    ...internalInfoSocialButtonsParams,
    ...internalInfoSocialButtonsHoverParams,
    ...externalInfoSocialButtonsParams,
    ...externalInfoSocialButtonsHoverParams,
  },
} as const;

export default generateSkinDefaults(proGallerySkinDefinition);
